<template>
	<span class="pa-1 ma-1" role="button" :style="disabled ? { cursor: 'not-allowed'} : {}">
		<span @click="startConfirmingPassword">
			<slot />
		</span>
		<!-- <v-snackbar top centered color="transparent" outlined v-model="checkingStatus"> -->
			<p class="text-center" v-show="checkingStatus" title="Checking password" style="position: fixed; z-index: 1000; top: 50vh; left: 50vw; background: white; padding: 10px; border-radius: 10px;">
				<v-icon large color="primary">mdi-reload mdi-flip-h mdi-spin</v-icon>
			</p>
		<!-- </v-snackbar> -->
		<mk-dialog v-model="confirmingPassword">
			<template slot="title">{{ title }}</template>
				<v-card class="ma-1" flat>
					<v-card-text>
						<p v-html="content"></p>
						<form @submit.prevent="confirmPassword">
						<div class="layout wrap username justify-start">
							<div class="flex flex-grow-0">UserName</div>
							<div class="flex flex-grow-0">{{ $user.username ? $user.username : $user.email }}</div>
						</div>
						<v-text-field type="password" prepend-inner-icon="mdi-key" placeholder="Your Current Password" dense clearable required ref="password" v-model="form.password" @keyup.enter.native="confirmPassword" :error-messages="form.error"></v-text-field>
						<v-btn small type="submit" class="primary pull-right" :loading="form.processing">{{ button }}</v-btn><br>
					</form>
					</v-card-text>
				</v-card>
		</mk-dialog>
	</span>
</template>

<script>
    const MkDialog = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/mk-dialog')

    export default {
			props: {
				title: {
					default: 'Confirm Password',
				},
				content: {
					default: 'For your security, please confirm your password to continue.',
				},
				button: {
					default: 'Confirm',
				},
				disabled: {
					default: false,
					type: Boolean,
				},
				instant: {
					type: Boolean,
					default: false,
				}
			},
			components: {
				MkDialog
			},
			data() {
				return {
					confirmingPassword: false,
					form: this.$inertia.form({
						password: '',
						error: '',
					}, {
						bag: 'confirmPassword',
					}),
					checkingStatus: false
				}
			},
			methods: {
				startConfirmingPassword() {
					if (this.disabled) {
						return;
					}
					this.form.error = '';
					this.checkingStatus = true;

					axios.get('/user/confirmed-password-status').then(response => {
						if (response.data.confirmed) {
							this.$emit('confirmed');
						} else {
							this.confirmingPassword = true;
							this.form.password = '';

							setTimeout(() => {
								this.$refs.password.focus()
							}, 250)
						}
					})
					.finally(() => {
						this.checkingStatus = false
					})
				},

				confirmPassword() {
					this.form.processing = true;
					axios.post('/user/confirm-password', {
						password: this.form.password,
					},
					{ headers: {
							'Accept': 'application/json'
						}
					}).then(response => {
						// console.log('response', response);
						this.confirmingPassword = false;
						this.form.password = '';
						this.form.error = '';
						this.form.processing = false;

						// this.$nextTick(() => this.$emit('confirmed'));
						this.$emit('confirmed')
					}).catch(error => {
						console.error('error', error);
						this.form.processing = false;
						this.form.error = error.response.data.errors.password[0];
					});
				}
			},
			mounted () {
				this.$nextTick(() => {
					if (this.instant) {
						this.startConfirmingPassword()
					}
				})
			},
			watch: {
				'instant': function (value) {
					if (value) {
						this.startConfirmingPassword()
					}
				}
			}
    }
</script>

<style scoped>
	.username {
		background: #0000ff29;
		border-radius: 10px;
		width: fit-content;
	}
	.username > div {
		padding: 0 10px;
		border-radius: 10px;
	}
	.username > div:first-child {
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
		background: #0000ff33;
	}
</style>
